import { env } from "environment-interface/env";
import { routes } from "routes";
import { createRouter } from "typed-client-router";

export const router = createRouter(routes, {
  base: env.PUBLIC_BASE_PATH,
});
